import React, { useState } from 'react'
import './auth.css';
import { Button, Form, Input, Typography } from 'antd';
import LilyButton from '../../components/button/lily-button';
import { useNavigate } from 'react-router-dom';
import portalAPI from '../../api/api';
import { REQUEST_OTP } from '../../api/URLs';
import LoginCardComponent from '../../components/login-card/login-card.component';

const LoginPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { Title, Text } = Typography;
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        email: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        let formattedValue = value;
        let validationError = '';

        // Update form field with formatted value
        form.setFieldsValue({ [name]: formattedValue });

        // Update error state
        setErrors((prev) => ({
            ...prev,
            [name]: validationError,
        }));
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const res = await portalAPI.post(REQUEST_OTP, values);

            if (res.data.status === 200) {
                navigate('/auth/verify-email', {
                    state: {
                        token: res.data.token || '',
                        email: values.email || '',
                    },
                });
            } else {
                navigate('/auth/sign-up', {
                    state: {
                        email: values.email || ''
                    }
                });
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='auth-layout'>
            <div className='auth-card'>
                <div className='d-flex flex-column h-100 mt-5'>
                    <div className='mb-4 d-flex flex-column align-items-center'>
                        <Title className='mb-1 text-center' level={3}>
                            Log In to Your Savings Card<br />Reimbursement Portal
                        </Title>
                    </div>
                    <Form
                        form={form}
                        name="access-card"
                        layout="vertical"
                        labelCol={{ span: 8 }}
                        initialValues={{
                            email: '',
                        }}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: 'Email is required' },
                                { type: 'email', message: 'Please enter a valid email address' }
                            ]}
                            validateStatus={errors.firstName ? 'error' : ''}
                            help={errors.firstName}
                            className='mb-3'
                        >
                            <Input name="email" onChange={handleChange} />
                        </Form.Item>
                    </Form>
                    <div className='d-flex flex-column justify-content-center align-items-center mt-3 gap-3'>
                        <LilyButton
                            text="Log in"
                            style={{
                                width: '200px'
                            }}
                            loading={loading}
                            size="large"
                            onClick={handleSubmit}
                        />
                        <Text>
                            No account? <Button
                                className='p-0'
                                color="default"
                                variant="link"
                                onClick={() => { navigate('/auth/sign-up') }}
                                style={{ color: 'var(--primary-button-color)' }}
                            >
                                Register here
                            </Button>
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage